import generateShareASaleHash from '@/services/generateShareASaleHash';
import ShareASaleLeadPixel from '@components/ShareASaleLeadPixel/ShareASaleLeadPixel';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import Image from 'next/future/image';
import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg'
import sendShareASalePixel from '../../services/sendShareASalePixel';
import { SchedulerThankYouStyles } from './SchedulerThankYouStyles';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const SchedulerThankYouComponent = ({
  appointment,
  calendarEventTitle,
  calendarEventDetails,
  close,
  title,
  subTitle,
  accountant,
  realAccountantDetails = null,
  customClass = false,
}) => {
  const [shareASaleHash, setShareASaleHash] = useState(false);

  const userTimezone = dayjs.tz.guess();
  let accountant_details = {
    image: {
      url: '/static/images/Susan_Young_color.png',
      alt: 'Susan Young',
    },
    name: 'Susan Young',
    job_title: '1-800Accountant Specialist',
  };

  if (accountant) {
    accountant_details = accountant;
  }

  // Use the real accountant details if coming from the accounting-services-v2-business page
  if (customClass === 'accounting-services-v2-business') {
    accountant_details = {
      image: {
        url: realAccountantDetails.UserPhoto,
        alt: 'real accoutnant',
      },
      name: realAccountantDetails.UserName,
      job_title: '1-800Accountant Specialist'
    }
  }

  const event = {
    title: calendarEventTitle,
    description: calendarEventDetails,
    location: '',
    startTime: appointment.selectedTime,
    endTime: dayjs(appointment.selectedTime)
      .add(30, 'm')
      .toDate(),
  };

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Lightbox Appointment Scheduled'); // Facebook event
    }
  }, []);

  useEffect(() => {
    const updateHash = async () => {
      const hash = await generateShareASaleHash();
      setShareASaleHash(hash);
    }
    updateHash();

    //Added timeout to wait for Pixel Image Load
    setTimeout(async function () {
      sendShareASalePixel();
    }, 4000);
  }, []);

  return (
    <SchedulerThankYouStyles className="scheduler-thank-you">
      {close && (
        <button type="button" className="close-btn" onClick={close}>
          <FontAwesomeIcon icon={faTimes} color="#333" />
        </button>
      )}
      {shareASaleHash ? <ShareASaleLeadPixel shareASaleHash={shareASaleHash} transType="lead" /> : ''}
      <div className="container text-center">
        <div className="col-md-6 col-12 pt-4">
          <h1 className="title">{title || 'Talk To You Soon!'}</h1>
          <p className="subtitle">{subTitle}</p>
          <div className="row appointment-details mt-4">
            <div className="col-md-8 offset-md-2 n">
              <div className="date">
                <ReactSVG className="svg-container" src="/static/images/icons/scheduler/calendar-white-3.svg?type=svg" />
                {appointment && (
                  <h3>{dayjs(appointment.selectedDate).format('dddd, MMM DD, YYYY')}</h3>
                )}
              </div>
              <div className="time">
                <ReactSVG className="svg-container" src="/static/images/icons/scheduler/clock-white-3.svg?type=svg" />
                {appointment && (
                  <h3>{dayjs(appointment.selectedTime).format('hh:mm A')}</h3>
                )}
              </div>
              <div className="timezone">
                <ReactSVG className="svg-container" src="/static/images/icons/scheduler/globe-white-3.svg?type=svg" />
                <h3>{userTimezone}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SchedulerThankYouStyles>
  );
};

export default SchedulerThankYouComponent;
